import {useAxios} from "@vueuse/integrations/useAxios";
import {IAddAttendanceRequest, ICreateLessonRequest, IDeleteAttendanceRequest, IGetResult, ILesson} from "@/types/api.ts";
import {axiosInstance} from "@/composables/axiosInstance.ts";
import {useFactoryFetch} from "@/composables/useFactoryFetch.ts";
import {AfterFetchContext} from "@vueuse/core";
import {API_URLS} from "@/utils/constants/api-urls.ts";

export class LessonService {

  static getInstance(): LessonService {
    return new LessonService();
  }

  async createLesson(body: ICreateLessonRequest): Promise<ILesson> {
    const {execute, data} = useAxios<IGetResult>(API_URLS.lessons.create, {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
    return data.value?.data?.data
  }

  async addAttendance(body: IAddAttendanceRequest): Promise<void> {
    const {execute} = useAxios<IGetResult>(API_URLS.lessons.addAttendance(body.lessonId), {
      method: "POST",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
  }

  async deleteAttendanceFromLesson(body: IDeleteAttendanceRequest): Promise<void> {
    const {execute} = useAxios<IGetResult>(API_URLS.lessons.deleteAttendanceFromLesson(body.lessonId, body.attendanceId), {
      method: "DELETE",
      data: body
    }, axiosInstance, {immediate: false})
    await execute();
  }

  getLessonById(lessonId: string) {
    return useFactoryFetch(API_URLS.lessons.getById(lessonId), {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.lesson}
      }
    }).get().json<ILesson>();
  }

  getLessons() {
    return useFactoryFetch(API_URLS.lessons.list, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.lessons}
      }
    }).json<ILesson[]>();
  }

  viewStudentAttendance() {
    return useFactoryFetch(API_URLS.lessons.viewStudentAttendance, {
      afterFetch(ctx: AfterFetchContext) {
        return {data: ctx?.data?.lessonsForStudent}
      }
    }).get().json<ILesson[]>();
  }

  async deleteLesson(lesson: ILesson) {
    const {execute} = useAxios<IGetResult>(API_URLS.lessons.deleteById(lesson._id), {
      method: "DELETE",
    }, axiosInstance, {immediate: false})
    await execute();
  }
}